import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function VolumeIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7145 3.29544C12.4115 2.63142 13.5162 3.15943 13.5162 4.15653V19.8435C13.5162 20.8504 12.3926 21.3745 11.7002 20.6906L6.00566 15.0667V8.73432L11.7145 3.29544ZM11.5134 6.35231L8.00849 9.6915V14.1324L11.5134 17.5939V6.35231Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M19.067 4.42484C22.9777 8.59864 22.9776 15.3658 19.0669 19.5396L17.6508 18.028C20.7794 14.689 20.779 9.27492 17.6504 5.93588L19.067 4.42484Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M16.2345 7.44777C18.581 9.95205 18.5809 14.0124 16.2344 16.5167L14.8183 15.0051C16.3826 13.3356 16.3822 10.6283 14.8179 8.95881L16.2345 7.44777Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M5.00425 8.69991H2V15.1125H5.00425V8.69991Z",
    fill: "currentColor"
  }));
}